import Vue from "vue";
import Vuex from "vuex";
import getters from "@/store/getters";
import mutations from "@/store/mutations";
import actions from "@/store/actions";
import sessionStorageKeys from "@/consts/sessionStorageKeys";
import { MainView } from "@/classes/views/mainView";
import { DEFAULT_GRID_ID } from "@/consts/consts";

Vue.use(Vuex);

const getInitialUploadedVideos = () => {
  let uploadedVideos = localStorage.getItem("uploadedVideos");
  return uploadedVideos ? JSON.parse(uploadedVideos) : [];
};

const getInitialStateVideos = () => {
  let uploadedVideos = localStorage.getItem("uploadedVideos");
  return uploadedVideos ? JSON.parse(uploadedVideos).length : 0;
};

const getInitialStreamQuality = () => {
  const streamQuality = sessionStorage.getItem(
    sessionStorageKeys.STREAM_QUALITY
  );
  return streamQuality ? JSON.parse(streamQuality) : 1;
};

const getInitialStreamMode = () => {
  const streamMode = sessionStorage.getItem(sessionStorageKeys.STREAM_MODE);
  return streamMode ? JSON.parse(streamMode) : 0;
};

export default new Vuex.Store({
  state: {
    user: false,
    cams: {},
    camIdFromCell: "",
    archCnvEnabled: true,
    mainView: new MainView(),
    localViews: [],
    globalViews: [],
    maps: [],
    mode: getInitialStreamMode(),
    alarms: [],
    grids: [
      { value: DEFAULT_GRID_ID, max: 1, icon: "grid-1" },
      { value: 2, max: 4, icon: "grid-4" },
      { value: 10, max: 4, icon: "grid-1-3" },
      { value: 11, max: 6, icon: "grid-1-5" },
      { value: 12, max: 6, icon: "grid-2-4" },
      { value: 13, max: 7, icon: "grid-4-3" },
      { value: 4, max: 9, icon: "grid-9" },
      { value: 5, max: 8, icon: "grid-1-7" },
      { value: 14, max: 12, icon: "grid-12" },
      { value: 7, max: 13, icon: "grid-1-12" },
      { value: 6, max: 16, icon: "grid-16" }
    ],
    grid: 1,
    stream: getInitialStreamQuality(),
    uploadedVideos: getInitialUploadedVideos(),
    videoState: {
      percent: 0,
      allVideoCount: getInitialStateVideos(),
      completeVideoCount: getInitialStateVideos(),
      status: "success"
    },
    wsWebConnect: null
  },
  getters,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./src/store/store.js